<template>
  <div class="container-custom" v-if="governance != null">
    <Breadscrumbs
      :links="[
        {
          name: 'Investor Relations',
          to: {
            path: '/investor-relations',
          },
        },
        {
          name: 'Edit',
          to: {
            path: '/investor-relations/edit',
          },
        },
        {
          name: typeName,
          to: {
            name: 'IRCorporateManagementEditinnerPage',
            params: {
              type: $route.params.type,
            }
          },
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯內頁</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- block -->
    <div class="block mb-5">
      <!-- Page Title -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5"><h4>Page Title</h4></div>
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="governance.page_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
    </div>

    <div class="page-divider mb-5"></div>

    <!-- content -->
    <Type1Component v-if="type === 1"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type1Component>
    <Type2Component v-if="type === 2"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type2Component>
    <Type3Component v-if="type === 3"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type3Component>
    <Type4Component v-if="type === 4"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type4Component>
    <Type5Component v-if="type === 5"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type5Component>
    <Type6Component v-if="type === 6"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type6Component>
    <Type7Component v-if="type === 7"
                    :content.sync="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type7Component>
    <Type8Component v-if="type === 8"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type8Component>
    <Type9Component v-if="type === 9"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type9Component>
    <Type10Component v-if="type === 10"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type10Component>
    <Type11Component v-if="type === 11"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type11Component>
    <Type12Component v-if="type === 12"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type12Component>
    <Type13Component v-if="type === 13"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type13Component>
    <Type14Component v-if="type === 14"
                    :content="governance.content"
                    @addItem="addItem"
                    @cancelHandler="cancelHandler"
                    @saveHandler="saveHandler"></Type14Component>

    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import Type1Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management1.vue';
import Type2Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management2.vue';
import Type3Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management3.vue';
import Type4Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management4.vue';
import Type5Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management5.vue';
import Type6Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management6.vue';
import Type7Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management7.vue';
import Type8Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management8.vue';
import Type9Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management9.vue';
import Type10Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management10.vue';
import Type11Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management11.vue';
import Type12Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management12.vue';
import Type13Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management13.vue';
import Type14Component from '@/views/I_IR/c/I-0-3-1-1__IR-Corporate Management14.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    Type1Component,
    Type2Component,
    Type3Component,
    Type4Component,
    Type5Component,
    Type6Component,
    Type7Component,
    Type8Component,
    Type9Component,
    Type10Component,
    Type11Component,
    Type12Component,
    Type13Component,
    Type14Component,
    LangDialog,
  },
  data: () => ({
    type: null,
    isLangOpen: false,
  }),
  async created() {
    this.type = parseInt(this.$route.params.type, 10);
    if (this.$route.params.type) {
      await this.findGovernance(this.$route.params.type);
    }
  },
  computed: {
    ...mapState(['lang']),
    ...mapState('ir', ['governance']),
    typeName() {
      let name = null;
      if (this.type === 1) {
        name = '致股東報告書';
      } else if (this.type === 2) {
        name = '董事會';
      } else if (this.type === 3) {
        name = '經營團隊';
      } else if (this.type === 4) {
        name = '治理守則';
      } else if (this.type === 5) {
        name = '組織架構';
      } else if (this.type === 6) {
        name = '重要公司內規';
      } else if (this.type === 7) {
        name = '董事會重要決議事項';
      } else if (this.type === 8) {
        name = '智財管理計畫';
      } else if (this.type === 9) {
        name = '委員會';
      } else if (this.type === 10) {
        name = '公司治理';
      } else if (this.type === 11) {
        name = '資通安全管理';
      } else if (this.type === 12) {
        name = '利害關係人聯絡窗口';
      } else if (this.type === 13) {
        name = '內部稽核';
      } else if (this.type === 14) {
        name = ' 誠信經營';
      }
      return name;
    },
  },
  methods: {
    ...mapActions('ir', ['findGovernance', 'saveGovernance']),
    addItem() {
      let template;
      if (this.type === 1 ||
          this.type === 4 ||
          this.type === 8) {
        template = {
          title: '',
          description: '',
        };
      } else if (this.type === 2 ||
                 this.type === 3 ||
                 this.type === 9 ||
                 this.type === 10 ||
                 this.type === 11 ||
                 this.type === 12 ||
                 this.type === 13 ||
                 this.type === 14) {
        template = {
          title: '',
          content: [],
        };
      } else if (this.type === 5) {
        template = {
          image: '',
        };
      } else if (this.type === 6) {
        template = {
          title: '',
          file: '',
        };
      } else if (this.type === 7) {
        template = {
          title: '',
          date: '',
          description: '',
        };
        this.governance.content.sections.push(template);
        return;
      }

      this.governance.content.push(template);
    },
    cancelHandler() {
      this.$router.push('/investor-relations/edit?section=2');
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.saveGovernance(this.governance).then(() => {
          this.$router.push('/investor-relations/edit?section=2');
          this.isLangOpen = false;
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
